<template>
  <v-snackbar v-model="isOpened" :timeout="6000" color="error" y="bottom">
    {{ message }}
    <v-btn variant="text" @click="close">Fermer</v-btn>
  </v-snackbar>
</template>

<script>
export default {
  name: 'AppSnackBar',
  computed: {
    isOpened() {
      return this.message !== null;
    },
    message() {
      return this.$store.getters['snackbar/getMessage'];
    },
  },
  methods: {
    close() {
      this.$store.dispatch('snackbar/close');
    },
  },
};
</script>
